import { api } from '@/api/client'

export interface PendingCelebrationsResponse {
  matches: unknown[]
  badge_events: unknown[]
  quiz_outcome_events: unknown[]
  fantasy_round_events: unknown[]
}

function asArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : []
}

function normalizePendingCelebrations(value: unknown): PendingCelebrationsResponse {
  if (!value || typeof value !== 'object') {
    return {
      matches: [],
      badge_events: [],
      quiz_outcome_events: [],
      fantasy_round_events: [],
    }
  }

  const payload = value as Record<string, unknown>
  return {
    matches: asArray(payload.matches),
    badge_events: asArray(payload.badge_events),
    quiz_outcome_events: asArray(payload.quiz_outcome_events),
    fantasy_round_events: asArray(payload.fantasy_round_events),
  }
}

export async function getPendingCelebrations(signal?: AbortSignal) {
  const response = await api.get<unknown>(
    '/celebrations/pending',
    signal ? { signal } : undefined,
  )
  return normalizePendingCelebrations(response)
}

export function hasPendingCelebrations(response: PendingCelebrationsResponse) {
  return (
    response.matches.length > 0 ||
    response.badge_events.length > 0 ||
    response.quiz_outcome_events.length > 0 ||
    response.fantasy_round_events.length > 0
  )
}

export async function markCelebrationsSeen() {
  await api.post('/celebrations/mark-seen', {})
}
